var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { ScrollableGrid } from "./ScrollableGrid";
import { ScrollbarSize } from "./constants";

var FilterValues = function (_ScrollableGrid) {
  _inherits(FilterValues, _ScrollableGrid);

  function FilterValues() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilterValues);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterValues.__proto__ || Object.getPrototypeOf(FilterValues)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (id, index) {
      _this.selectCell({ rows: index, columns: 0 });
      _this.props.onChangeCheck(id, index);
    }, _this.selectRange = function (range) {
      _this.focusedIndex = range.end.rows;
      _this.setState({ selectedRange: range });
    }, _this.getRowWidth = function () {
      _this.rowWidth = _this.props.width - ScrollbarSize;
      _this.lockedWidth = 0;
    }, _this.getContent = function () {
      var items = [];
      var i = 0,
          index = _this.state.scroll.rows.startIndex;
      var _this$props = _this.props,
          filter = _this$props.filter,
          rowCount = _this$props.rowCount,
          height = _this$props.height,
          rowHeight = _this$props.rowHeight;

      var _loop = function _loop() {
        var _this$props$data$inde = _this.props.data[index],
            id = _this$props$data$inde.id,
            label = _this$props$data$inde.label;

        var style = { height: rowHeight, width: "inherit", display: "flex" };
        if (index === _this.state.selectedRange.end.rows) {
          style.backgroundColor = "aliceblue";
        }
        var ix = index;
        items.push(React.createElement(
          "div",
          { key: index, style: style },
          React.createElement("input", {
            id: "checkbox " + index,
            type: "checkbox",
            checked: filter[id] !== undefined,
            onChange: function onChange() {
              return _this.onClick(id, ix);
            }
          }),
          React.createElement(
            "div",
            { onClick: function onClick() {
                return _this.onClick(id, ix);
              } },
            label
          )
        ));
        index++;
        i++;
      };

      while (index < rowCount && i < height / rowHeight) {
        _loop();
      }
      return React.createElement(
        "div",
        { id: "content", style: {}, onWheel: _this.onWheel },
        items
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilterValues, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusedIndex !== undefined) {
        var element = document.getElementById("checkbox " + this.focusedIndex);
        if (element) {
          element.focus();
        }
        this.focusedIndex = undefined;
      }
    }
  }]);

  return FilterValues;
}(ScrollableGrid);

export var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this2 = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this2.filterItems = function (value) {
      var v = value.toLowerCase();
      var items = _this2.props.items.filter(function (item) {
        return String(item.label).toLowerCase().startsWith(v);
      });
      _this2.setState({
        items: items,
        rowCount: items.length,
        changed: !_this2.state.changed
      });
    };

    _this2.onChangeCheck = function (id, index) {
      var filter = _this2.state.filter;
      var checked = filter[id] === undefined;
      if (checked) {
        filter[id] = id;
      } else {
        delete filter[id];
      }
      _this2.setState({ filter: filter, index: index, changed: !_this2.state.changed });
      //this.selectCell({ rows: index, columns: 0 });
    };

    _this2.onChangeCheckAll = function () {
      var filter = _this2.state.items.reduce(function (acc, item) {
        if (_this2.state.checkAll) {
          delete acc[item.id];
          return acc;
        } else {
          acc[item.id] = item.id;
          return acc;
        }
      }, Object.assign({}, _this2.state.filter));
      _this2.setState({
        filter: filter,
        checkAll: !_this2.state.checkAll,
        changed: !_this2.state.changed
      });
    };

    _this2.onOk = function () {
      var filterKeys = Object.values(_this2.state.filter);
      var filter = filterKeys.length === _this2.props.items.length || filterKeys.length === 0 ? null : _this2.state.filter;
      _this2.props.onOk(filter);
    };

    _this2.state = {
      items: [].concat(_toConsumableArray(props.items)),
      filter: Object.assign({}, props.filter),
      rowCount: props.items.length,
      checkAll: false,
      maxRows: props.maxRows || 10,
      rowHeight: props.rowHeight || 20
    };
    return _this2;
  }

  _createClass(Filter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.keyEvent !== nextProps.keyEvent && this.values) {
        this.values.handleNavigationKeys(nextProps.keyEvent);
      } else if (nextProps.items !== this.props.items || nextProps.filter !== this.props.filter) {
        this.setState({
          items: [].concat(_toConsumableArray(nextProps.items)),
          filter: Object.assign({}, nextProps.filter),
          rowCount: nextProps.items.length
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.keyEvent === nextProps.keyEvent;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          maxRows = _state.maxRows,
          rowHeight = _state.rowHeight;

      return React.createElement(
        "div",
        {
          id: "filter",
          style: Object.assign({}, this.props.style, {
            height: "fit-content"
          }),
          onWheel: this.onWheel
        },
        React.createElement(
          "div",
          { style: { textAlign: "center" } },
          this.props.title || "Filter"
        ),
        React.createElement(
          "div",
          null,
          React.createElement("input", {
            type: "text",
            style: {
              width: "94%",
              margin: "2%",
              placeholder: "toto",
              textAlign: "left"
            },
            autoFocus: true,
            value: this.value,
            onChange: function onChange(e) {
              return _this3.filterItems(e.target.value);
            }
          })
        ),
        React.createElement(
          "div",
          null,
          React.createElement("input", {
            id: "-1",
            value: "0",
            type: "checkbox",
            checked: this.state.checkAll,
            onChange: this.onChangeCheckAll
          }),
          "Select all",
          React.createElement(FilterValues, {
            width: (this.props.style.width || 200) * 0.98,
            height: maxRows * rowHeight - 5,
            style: {
              width: (this.props.style.width || 200) * 0.98,
              justifyContent: "space-between",
              borderTop: "solid 0.02em rgba(0, 0, 0, 0.3)",
              marginTop: 5
            },
            rowCount: this.state.rowCount,
            rowHeight: rowHeight,
            data: this.state.items,
            filter: this.state.filter,
            onChangeCheck: this.onChangeCheck,
            changed: this.state.changed,
            ref: function ref(_ref2) {
              return _this3.values = _ref2;
            }
          })
        ),
        React.createElement(
          "button",
          { style: { width: "96%", margin: "2%" }, onClick: this.onOk },
          "Apply filter"
        )
      );
    }
  }]);

  return Filter;
}(Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/Filter.js
// module id = 299
// module chunks = 0